// Spanish labels for the Agreements module's stored codes. The codes themselves
// are English (backend convention); everything the gestor ve en pantalla se
// traduce aquí, de modo que ningún Chip ni ningún mensaje de error muestre el
// código crudo.
import { AGREEMENT_STATUS, AGREEMENT_TYPE } from "../../constants";

export const AGREEMENT_TYPE_LABELS = {
  [AGREEMENT_TYPE.AGREEMENT]: "Convenio",
  [AGREEMENT_TYPE.CONTRACT]: "Contrato",
};

// Etapa del convenio. El vocabulario es el del documento de diseño:
// EN_ESTUDIO / EN_EJECUCION / FINALIZADO / LIQUIDADO.
export const AGREEMENT_STATUS_LABELS = {
  [AGREEMENT_STATUS.UNDER_REVIEW]: "En estudio",
  [AGREEMENT_STATUS.IN_PROGRESS]: "En ejecución",
  [AGREEMENT_STATUS.FINISHED]: "Finalizado",
  [AGREEMENT_STATUS.SETTLED]: "Liquidado",
};

export const AGREEMENT_STATUS_COLOR = {
  [AGREEMENT_STATUS.UNDER_REVIEW]: "default",
  [AGREEMENT_STATUS.IN_PROGRESS]: "success",
  [AGREEMENT_STATUS.FINISHED]: "info",
  [AGREEMENT_STATUS.SETTLED]: "warning",
};

// Códigos de validación → texto accionable. Los produce agreementLogic (en el
// formulario) y también los devuelve handleAgreement, así que una regla que se
// valida en ambos lados se lee igual venga de donde venga.
export const AGREEMENT_ERROR_LABELS = {
  CODE_REQUIRED: "El código del convenio es obligatorio.",
  SUBJECT_TOO_SHORT: "Describe el objeto del convenio (mínimo 10 caracteres).",
  ENTITY_REQUIRED: "Selecciona la entidad contratante del registro de entidades.",
  INVALID_TYPE: "Selecciona si es un convenio o un contrato.",
  INVALID_STATUS: "Selecciona el estado del convenio.",
  INVALID_START_DATE: "La fecha de inicio no es válida.",
  INVALID_END_DATE: "La fecha de terminación no es válida.",
  END_NOT_AFTER_START: "La fecha de terminación debe ser posterior a la de inicio.",
  VALUE_NOT_POSITIVE: "El valor del convenio debe ser mayor que cero.",
  COMMITTED_NEGATIVE: "El valor comprometido no puede ser negativo.",
  COMMITTED_EXCEEDS_TOTAL: "El valor comprometido no puede superar el valor del convenio.",
};

// Errores que devuelve la función y que no son de un campo concreto.
export const AGREEMENT_REQUEST_ERROR_LABELS = {
  ALREADY_EXISTS: "Ya existe un convenio con ese código.",
  NOT_FOUND: "El convenio ya no existe. Recarga la página.",
  FORBIDDEN: "No tienes permiso para realizar esta acción.",
  VALIDATION_ERROR: "Revisa los campos marcados.",
  ENTITY_NOT_FOUND:
    "La entidad contratante ya no existe. Recarga la página y vuelve a seleccionarla.",
  ENTITY_INACTIVE:
    "La entidad contratante está inactiva. Actívala en el registro de entidades antes de asociarle un convenio.",
  ENTITY_PENDING:
    "La entidad se registró por el portal y aún no ha sido aprobada. Revísala en el registro de entidades y apruébala antes de asociarle un convenio.",
};

// Traduce un código, dejándolo tal cual si no está mapeado (nunca oculta datos).
export const labelForCode = (map, code, fallback = "—") => map[code] || code || fallback;

// Formato de moneda del resto de la app: pesos colombianos, sin decimales.
export const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  });
};

// Versión compacta para las cifras del tablero: "$4,2 M" en vez de
// "$4.200.000.000". Las tarjetas muestran magnitudes, no cifras exactas — el
// valor exacto de cada convenio está en la tabla y en su ficha.
export const formatMoneyCompact = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    notation: "compact",
    maximumFractionDigits: 1,
  });
};

// "15 ene 2026" a partir de una fecha ISO date-only, sin pasar por la zona
// horaria local (que restaría un día a las fechas guardadas como YYYY-MM-DD).
export const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(`${value}T00:00:00Z`);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
};
